import * as React from "react";

import { cn } from "@/lib/cn";

const Input = ({ className, type, ...props }: React.ComponentProps<"input">) => (
  <input
    type={type}
    data-slot="input"
    className={cn(
      // Layout
      "flex h-12 w-full px-4 py-3",
      // Background & Border
      "rounded-sm bg-neutral-200/2",
      "border-2 border-transparent transition-colors",
      // Typography
      "fs-300 font-semibold text-neutral-200",
      // Placeholder
      "placeholder:font-semibold placeholder:text-neutral-200/22 placeholder:select-none",
      // Hover state
      "hover:border-neutral-200/22",
      // Focus state
      "focus-visible:border-primary-800/63 focus-visible:outline-none",
      // Disabled state
      "disabled:pointer-events-none disabled:cursor-not-allowed disabled:text-neutral-200/12",
      // Invalid state
      "aria-invalid:border-danger",
      // File input
      "file:text-foreground file:fs-200 file:border-0 file:bg-transparent file:font-semibold",
      // Autofill - neutral-900 bg (dark), neutral-200 text
      "autofill:shadow-[inset_0_0_0px_1000px_#101012] autofill:[-webkit-text-fill-color:#bfbfbf]",
      className
    )}
    {...props}
  />
);

export { Input };
